import React, { useEffect, useState } from "react";
import { IMaskMixin } from "react-imask";
import IMask from "imask";
import { Input } from "@rebass/forms";

const MaskedInputElement = IMaskMixin(({ inputRef, ...props }) => (
  <Input {...props} ref={inputRef} />
));

export default ({ value: _value, onChange, onBlur, ...props }) => {
  const [value, setValue] = useState(_value);

  useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [value, onChange]);

  useEffect(() => {
    setValue(_value);
  }, [_value]);

  const handleOnAccept = unMaskedValue => {
    setValue(unMaskedValue);
  };

  const handleOnChange = e => {
    setValue(e?.target?.value);
  };

  const handleOnBlur = e => {
    if (onBlur) {
      onBlur(e, value);
    }
  };

  return (
    <MaskedInputElement
      value={value}
      onChange={handleOnChange}
      onAccept={handleOnAccept}
      onBlur={handleOnBlur}
      {...props}
    />
  );
};

export { IMask };
